/**
 * `data-component-props` ile tüm blok JSON'unu HTML'e yazmak:
 * - Sayfa kaynağında veri sızıntısı ve şişkin DOM oluşturur.
 * - Üretimde varsayılan olarak kapalı; yalnızca sayfa editörü / önizleme için açılır.
 *
 * Açmak için: NEXT_PUBLIC_PAGE_BUILDER_EMBED_PROPS=true
 * Zorla kapatmak için (ör. staging): NEXT_PUBLIC_PAGE_BUILDER_EMBED_PROPS=false
 */
export function shouldEmbedBlockPropsInDom(): boolean {
  const v = process.env.NEXT_PUBLIC_PAGE_BUILDER_EMBED_PROPS;
  if (v === 'false') return false;
  if (v === 'true') return true;
  return process.env.NODE_ENV !== 'production';
}

/**
 * `PageRenderer` kökünde `data-component-props` için güvenli JSON.
 * Döngüsel referans veya serileştirilemeyen değerlerde `{}` döner.
 */
export function serializeBlockPropsForDomEmbed(props: Record<string, unknown>): string {
  try {
    const s = JSON.stringify(props, (_key, value) => {
      if (value === undefined) return undefined;
      if (typeof value === 'function' || typeof value === 'symbol') return undefined;
      if (typeof value === 'bigint') return value.toString();
      return value;
    });
    return s ?? '{}';
  } catch {
    return '{}';
  }
}
